import { ScrollArea, Stack, createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
	groupedChatsWrapper: {
		height: '100%',
		gap: theme.spacing.md,
		padding: `0 ${theme.spacing.md}`,
	},
	scrollAreaViewport: {
		paddingBottom: theme.spacing['xl'],

		'>div': {
			display: 'block !important',
		},
	},
}));

export function AiChatHistoryBody({ children }: { children: React.ReactNode }) {
	const { classes } = useStyles();

	return (
		<ScrollArea
			classNames={{
				viewport: classes.scrollAreaViewport,
			}}
			type="scroll"
		>
			<Stack className={classes.groupedChatsWrapper}>{children}</Stack>
		</ScrollArea>
	);
}
